"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountLoading = exports.fadeIn = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const shared_1 = require("../../shared");
const time = 600;
exports.fadeIn = (0, styled_components_1.keyframes) `
    0% {
        opacity: 0.2;
        transform: scale3d(1,1,1);
    }
    100% {
        opacity: 1;
        transform: scale3d(1.2,1.2,1);
    }
`;
const Styled = styled_components_1.default.div `
	height: 100%;
	width: 100px;
	padding: 16px 12px;
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	align-content: center;
	justify-content: space-evenly;
	align-items: center;

	.eg-header-icon-user {
		margin-top: -2px;
	}

	.dots {
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: space-evenly;
		align-items: center;
		width: 100px;
		height: 15px;
		line-height: 16px;

		> span {
			border-radius: 50%;
			height: 8px;
			width: 8px;
			display: block;
			background-color: ${(p) => p.theme.palette.text.primary};
			opacity: 0.25;
			transform: scale3d(1, 1, 1);
			will-change: opacity, transform;
			transition: opacity 0.2s ${(p) => p.theme.easing}, transform 0.2s ${(p) => p.theme.easing};

			&.active {
				animation: ${exports.fadeIn} ${time}ms 0s;
			}
		}
	}
`;
const AccountLoading = () => {
    const [active, setActive] = (0, react_1.useState)(1);
    const { messages } = (0, shared_1.useMessages)();
    (0, react_1.useEffect)(() => {
        const timeout = setTimeout(() => {
            let next = active + 1;
            if (next > 3) {
                next = 1;
            }
            setActive(next);
        }, time);
        return () => {
            clearTimeout(timeout);
        };
    }, [active, setActive]);
    return (react_1.default.createElement(Styled, { title: messages.loading },
        react_1.default.createElement("i", { className: "eg-header-icon-user" }),
        react_1.default.createElement("div", { className: "dots" },
            react_1.default.createElement("span", { className: `one ${active === 1 ? "active" : ""}` }),
            react_1.default.createElement("span", { className: `two ${active === 2 ? "active" : ""}` }),
            react_1.default.createElement("span", { className: `three ${active === 3 ? "active" : ""}` }))));
};
exports.AccountLoading = AccountLoading;
//# sourceMappingURL=AccountLoading.js.map